import React, { useState, useMemo } from 'react';

const METHODS = [
  { id: 'zscore', name: 'Z-Score', category: 'İstatistiksel', desc: 'Ortalamadan ±2 standart sapma uzaklığındaki değerleri anomali olarak işaretler. Basit ama etkili.' },
  { id: 'iqr', name: 'IQR', category: 'İstatistiksel', desc: 'Q1−1.5×IQR altı veya Q3+1.5×IQR üstü değerler. Aşırı değerlere dayanıklı (robust).' },
  { id: 'moving_avg', name: 'Hareketli Ortalama', category: 'İstatistiksel', desc: '3 aylık hareketli ortalamadan %30+ sapan dönemleri tespit eder.' },
  { id: 'exp_ma', name: 'Üstel Hareketli Ort.', category: 'İstatistiksel', desc: 'Son değerlere daha çok ağırlık veren ortalama ile trend sapması arar.' },
  { id: 'seasonal', name: 'Mevsimsel Ayrıştırma', category: 'Zaman Serisi', desc: 'Mevsimsel bileşen çıkarıldıktan sonra kalan artık (residual) analizini yapar.' },
  { id: 'isolation_forest', name: 'Isolation Forest', category: 'Makine Öğrenmesi', desc: 'Rastgele ağaç bölümlemesi ile kolayca izole edilebilen (anormal) noktaları bulur. Çok boyutlu veriye uygun.' },
  { id: 'lof', name: 'Local Outlier Factor', category: 'Makine Öğrenmesi', desc: 'Her noktanın komşularına göre yerel yoğunluğunu karşılaştırır. Düşük yoğunluklu noktalar anomali.' },
  { id: 'cusum', name: 'CUSUM', category: 'Zaman Serisi', desc: 'Kümülatif toplam kontrolü. Sürekli tek yönlü sapmaları (drift) erken tespit eder.' },
  { id: 'dbscan', name: 'DBSCAN', category: 'Makine Öğrenmesi', desc: 'Yoğunluk bazlı kümeleme. Hiçbir kümeye atanamayan noktalar anomali (gürültü noktası).' },
  { id: 'grubbs', name: 'Grubbs Testi', category: 'İstatistiksel', desc: 'Normal dağılım varsayımı ile tek aykırı değer testi. p<0.05 ise anomali.' },
  { id: 'mad', name: 'MAD', category: 'İstatistiksel', desc: 'Medyandan mutlak sapma. Aşırı değerlere çok dayanıklı, robust bir yöntem.' },
  { id: 'stl', name: 'STL Ayrıştırma', category: 'Zaman Serisi', desc: 'Seasonal + Trend + Residual ayrıştırması. Artık bileşen eşik aşarsa anomali.' },
  { id: 'ml_anomaly', name: 'ML Hibrit (Prophet)', category: 'Makine Öğrenmesi', desc: 'Prophet tahmin-gerçek farkı analizi. Model beklemediği büyük sapmalar = anomali.' },
];

const CATEGORY_COLORS = {
  'İstatistiksel': { bg: '#eff6ff', border: '#bfdbfe', text: '#1e40af' },
  'Makine Öğrenmesi': { bg: '#fdf2f8', border: '#fbcfe8', text: '#9d174d' },
  'Zaman Serisi': { bg: '#f0fdf4', border: '#bbf7d0', text: '#166534' },
};

const generateAnomalyData = () => {
  const seeded = (s) => { const x = Math.sin(s * 9301 + 49297) * 233280; return x - Math.floor(x); };
  const parks = [
    { park: 'Kuğulu Park', ilce: 'Çankaya', aboneNo: '034567' },
    { park: 'Botanik Parkı', ilce: 'Çankaya', aboneNo: '034890' },
    { park: 'Gençlik Parkı', ilce: 'Altındağ', aboneNo: '012345' },
    { park: 'Anıtpark', ilce: 'Çankaya', aboneNo: '034123' },
    { park: 'Güvenpark', ilce: 'Çankaya', aboneNo: '034456' },
    { park: 'Harikalar Diyarı', ilce: 'Sincan', aboneNo: '078901' },
    { park: 'Altınpark', ilce: 'Altındağ', aboneNo: '012678' },
    { park: 'Dikmen Vadisi', ilce: 'Çankaya', aboneNo: '034789' },
    { park: '50. Yıl Parkı', ilce: 'Çankaya', aboneNo: '035001' },
    { park: 'Seğmenler Parkı', ilce: 'Çankaya', aboneNo: '034234' },
  ];

  return parks.map((p, i) => {
    const normalConsumption = 200 + seeded(i * 13) * 800;
    const actual = normalConsumption * (1 + (seeded(i * 7 + 3) > 0.7 ? (seeded(i * 11) * 2 + 0.5) : seeded(i * 5) * 0.3 - 0.15));
    const deviation = ((actual - normalConsumption) / normalConsumption) * 100;
    const isAnomaly = Math.abs(deviation) > 40;
    const detectedBy = isAnomaly
      ? METHODS.filter((_, mi) => seeded(i * 17 + mi) > 0.5).slice(0, 3 + Math.floor(seeded(i * 23) * 4)).map(m => m.name)
      : [];
    const severity = Math.abs(deviation) > 100 ? 'critical' : Math.abs(deviation) > 60 ? 'high' : Math.abs(deviation) > 40 ? 'medium' : 'low';
    const reason = deviation > 100 ? 'Olası boru patlaması / ciddi kaçak'
      : deviation > 60 ? 'Anormal tüketim artışı - sayaç arızası olabilir'
      : deviation > 40 ? 'Mevsim dışı yüksek tüketim - sulama programı kontrol edilmeli'
      : deviation < -30 ? 'Beklenenden düşük tüketim - sayaç durmuş olabilir'
      : '';

    return {
      ...p,
      normalConsumption: Math.round(normalConsumption),
      actual: Math.round(actual),
      deviation: Math.round(deviation * 10) / 10,
      isAnomaly,
      detectedBy,
      severity,
      reason,
      period: 'Nisan 2026'
    };
  }).sort((a, b) => Math.abs(b.deviation) - Math.abs(a.deviation));
};

const AnomalyDetection = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [showMethodDetail, setShowMethodDetail] = useState(null);
  const anomalyData = useMemo(() => generateAnomalyData(), []);
  const anomalies = anomalyData.filter(d => d.isAnomaly);

  const filteredMethods = selectedCategory === 'all'
    ? METHODS
    : METHODS.filter(m => m.category === selectedCategory);

  const getSeverityStyle = (severity) => {
    switch (severity) {
      case 'critical': return { bg: '#fef2f2', border: '#fecaca', text: '#991b1b', label: 'Kritik' };
      case 'high': return { bg: '#fff7ed', border: '#fed7aa', text: '#9a3412', label: 'Yüksek' };
      case 'medium': return { bg: '#fefce8', border: '#fde68a', text: '#854d0e', label: 'Orta' };
      default: return { bg: '#f0fdf4', border: '#bbf7d0', text: '#166534', label: 'Düşük' };
    }
  };

  return (
    <div style={{ padding: '24px' }}>
      <div style={{ marginBottom: '24px' }}>
        <h2 style={{ fontSize: '20px', fontWeight: '700', color: '#1a1a2e', marginBottom: '4px' }}>
          Anomali Tespiti
        </h2>
        <p style={{ fontSize: '13px', color: '#666', margin: 0 }}>
          13 Farklı Yöntem • Isolation Forest + İstatistiksel + Zaman Serisi
        </p>
      </div>

      {/* Açıklama */}
      <div style={{ background: '#fef3c7', border: '1px solid #fde68a', borderRadius: '12px', padding: '18px', marginBottom: '24px' }}>
        <h4 style={{ fontSize: '14px', fontWeight: '700', color: '#92400e', margin: '0 0 8px 0' }}>Bu Bölüm Ne Yapıyor?</h4>
        <p style={{ fontSize: '12px', color: '#374151', margin: '0 0 8px 0', lineHeight: 1.7 }}>
          Her parkın su tüketim verisini <strong>13 farklı anomali tespit yöntemiyle</strong> analiz eder.
          Anormal tüketim gösteren parkları otomatik tespit ederek olası <strong>boru patlaması, kaçak, sayaç arızası veya yanlış sulama programı</strong> gibi sorunları erken aşamada yakalar.
        </p>
        <p style={{ fontSize: '12px', color: '#374151', margin: 0, lineHeight: 1.7 }}>
          Yöntemler 3 kategoriden oluşur: <strong>İstatistiksel</strong> (Z-Score, IQR, MAD — basit ve hızlı),
          <strong> Makine Öğrenmesi</strong> (Isolation Forest, DBSCAN, LOF — çok boyutlu örüntü tanıma) ve
          <strong> Zaman Serisi</strong> (CUSUM, STL, mevsimsel ayrıştırma — zamansal bağlamda tespit).
          Birden fazla yöntem aynı parkı işaretliyorsa güvenilirlik artar.
        </p>
      </div>

      {/* Özet Kartları */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '16px', marginBottom: '28px' }}>
        <div style={{ background: '#fef2f2', border: '1px solid #fecaca', borderRadius: '10px', padding: '18px', textAlign: 'center' }}>
          <div style={{ fontSize: '28px', fontWeight: '800', color: '#991b1b' }}>{anomalies.length}</div>
          <div style={{ fontSize: '11px', color: '#dc2626', marginTop: '4px', fontWeight: '600' }}>Anomali Tespit Edilen</div>
          <div style={{ fontSize: '10px', color: '#6b7280', marginTop: '4px' }}>Toplam {anomalyData.length} parktan</div>
        </div>
        <div style={{ background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: '10px', padding: '18px', textAlign: 'center' }}>
          <div style={{ fontSize: '28px', fontWeight: '800', color: '#166534' }}>13</div>
          <div style={{ fontSize: '11px', color: '#15803d', marginTop: '4px', fontWeight: '600' }}>Tespit Yöntemi</div>
          <div style={{ fontSize: '10px', color: '#6b7280', marginTop: '4px' }}>3 kategori, paralel çalışır</div>
        </div>
        <div style={{ background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: '10px', padding: '18px', textAlign: 'center' }}>
          <div style={{ fontSize: '28px', fontWeight: '800', color: '#1e40af' }}>{anomalies.filter(a => a.severity === 'critical').length}</div>
          <div style={{ fontSize: '11px', color: '#1d4ed8', marginTop: '4px', fontWeight: '600' }}>Kritik Seviye</div>
          <div style={{ fontSize: '10px', color: '#6b7280', marginTop: '4px' }}>Acil müdahale gerekli</div>
        </div>
        <div style={{ background: '#fefce8', border: '1px solid #fde68a', borderRadius: '10px', padding: '18px', textAlign: 'center' }}>
          <div style={{ fontSize: '28px', fontWeight: '800', color: '#92400e' }}>
            %{anomalyData.length > 0 ? Math.round((anomalies.length / anomalyData.length) * 100) : 0}
          </div>
          <div style={{ fontSize: '11px', color: '#a16207', marginTop: '4px', fontWeight: '600' }}>Anomali Oranı</div>
          <div style={{ fontSize: '10px', color: '#6b7280', marginTop: '4px' }}>İncelenmesi gereken parklar</div>
        </div>
      </div>

      {/* Yöntemler Tablosu */}
      <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: '12px', padding: '24px', marginBottom: '24px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
          <h3 style={{ fontSize: '15px', fontWeight: '700', color: '#1a1a2e', margin: 0 }}>
            Kullanılan Yöntemler (13)
          </h3>
          <div style={{ display: 'flex', gap: '8px' }}>
            {['all', 'İstatistiksel', 'Makine Öğrenmesi', 'Zaman Serisi'].map(cat => (
              <button
                key={cat}
                onClick={() => setSelectedCategory(cat)}
                style={{
                  padding: '4px 12px', fontSize: '11px', fontWeight: '600', borderRadius: '16px',
                  border: `1px solid ${selectedCategory === cat ? '#2563eb' : '#e5e7eb'}`,
                  background: selectedCategory === cat ? '#eff6ff' : '#fff',
                  color: selectedCategory === cat ? '#2563eb' : '#6b7280',
                  cursor: 'pointer'
                }}
              >
                {cat === 'all' ? 'Tümü' : cat}
              </button>
            ))}
          </div>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '10px' }}>
          {filteredMethods.map(m => {
            const catColor = CATEGORY_COLORS[m.category];
            return (
              <div
                key={m.id}
                onClick={() => setShowMethodDetail(showMethodDetail === m.id ? null : m.id)}
                style={{
                  background: catColor.bg, border: `1px solid ${catColor.border}`,
                  borderRadius: '8px', padding: '12px', cursor: 'pointer',
                  transition: 'all 0.2s ease'
                }}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span style={{ fontSize: '12px', fontWeight: '700', color: catColor.text }}>{m.name}</span>
                  <span style={{ fontSize: '9px', background: catColor.border, color: catColor.text, padding: '2px 6px', borderRadius: '8px', fontWeight: '600' }}>
                    {m.category}
                  </span>
                </div>
                {showMethodDetail === m.id && (
                  <div style={{ fontSize: '11px', color: '#374151', marginTop: '8px', lineHeight: 1.5 }}>
                    {m.desc}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>

      {/* Anomali Listesi */}
      <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: '12px', padding: '24px' }}>
        <h3 style={{ fontSize: '15px', fontWeight: '700', marginBottom: '16px', color: '#1a1a2e' }}>
          Tespit Edilen Anomaliler ({anomalies.length} park)
        </h3>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          {anomalies.map((a, i) => {
            const sev = getSeverityStyle(a.severity);
            return (
              <div key={i} style={{ background: sev.bg, border: `1px solid ${sev.border}`, borderRadius: '10px', padding: '16px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '8px' }}>
                  <div>
                    <span style={{ fontSize: '13px', fontWeight: '700', color: '#1a1a2e' }}>{a.park}</span>
                    <span style={{ fontSize: '11px', color: '#6b7280', marginLeft: '8px' }}>{a.ilce} • Abone: {a.aboneNo}</span>
                  </div>
                  <span style={{ fontSize: '10px', fontWeight: '700', padding: '3px 10px', borderRadius: '10px', background: sev.border, color: sev.text }}>
                    {sev.label}
                  </span>
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '12px', marginBottom: '8px', fontSize: '11px' }}>
                  <div>
                    <span style={{ color: '#6b7280' }}>Beklenen: </span>
                    <strong>{a.normalConsumption.toLocaleString('tr-TR')} m³</strong>
                  </div>
                  <div>
                    <span style={{ color: '#6b7280' }}>Gerçekleşen: </span>
                    <strong>{a.actual.toLocaleString('tr-TR')} m³</strong>
                  </div>
                  <div>
                    <span style={{ color: '#6b7280' }}>Sapma: </span>
                    <strong style={{ color: a.deviation > 0 ? '#dc2626' : '#2563eb' }}>
                      {a.deviation > 0 ? '+' : ''}{a.deviation}%
                    </strong>
                  </div>
                </div>
                <div style={{ fontSize: '11px', color: '#374151', marginBottom: '6px' }}>
                  <strong>Olası Neden:</strong> {a.reason}
                </div>
                <div style={{ fontSize: '10px', color: '#6b7280' }}>
                  <strong>Tespit Eden Yöntemler ({a.detectedBy.length}):</strong>{' '}
                  {a.detectedBy.join(', ')}
                </div>
              </div>
            );
          })}
        </div>
        {anomalies.length === 0 && (
          <div style={{ textAlign: 'center', padding: '40px', color: '#6b7280', fontSize: '13px' }}>
            Bu dönemde anomali tespit edilmedi.
          </div>
        )}
      </div>

      {/* Isolation Forest Detay */}
      <div style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '12px', padding: '20px', marginTop: '20px' }}>
        <h3 style={{ fontSize: '14px', fontWeight: '700', marginBottom: '12px', color: '#1a1a2e' }}>
          Isolation Forest Nasıl Çalışır?
        </h3>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
          <div style={{ fontSize: '12px', color: '#374151', lineHeight: 1.8 }}>
            <p style={{ margin: '0 0 10px 0' }}>
              Isolation Forest, anormal veri noktalarının <strong>"izole edilmesi kolay"</strong> olduğu prensibine dayanır.
              Normal veriler birbirine yakın ve yoğun kümelerde bulunurken, anomaliler ayrık ve seyrek bölgelerdedir.
            </p>
            <p style={{ margin: 0 }}>
              Algoritma rastgele ağaçlar oluşturur. Bir noktayı izole etmek için gereken ortalama bölme sayısı düşükse → anomali.
              Çok boyutlu veriye uygulanabilir (tüketim + sıcaklık + mevsim + alan m²).
            </p>
          </div>
          <div style={{ fontSize: '11px' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <tbody>
                {[
                  ['Girdi', 'Park tüketim vektörü (aylık m³, alan, ilçe)'],
                  ['Ağaç Sayısı', '100 (ensemble)'],
                  ['Contamination', '0.05 (beklenen anomali oranı)'],
                  ['Çıktı', 'Anomaly score (-1: anomali, 1: normal)'],
                  ['Avantaj', 'Etiketlenmemiş veriyle çalışır (unsupervised)'],
                  ['Uygulama', 'scikit-learn IsolationForest'],
                ].map(([label, value], i) => (
                  <tr key={i} style={{ borderBottom: '1px solid #e2e8f0' }}>
                    <td style={{ padding: '6px 0', color: '#6b7280', fontWeight: '600' }}>{label}</td>
                    <td style={{ padding: '6px 0', color: '#1a1a2e' }}>{value}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnomalyDetection;
